import {
  ClassicEditorUI,
  EditorConfig,
  EditorUI,
  EditorUIView,
} from 'ckeditor5';

export const CKEditorConfig: EditorConfig = {
  toolbar: {
    items: [
      'bold',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      '|',
      'outdent',
      'indent',
      '|',
      'blockQuote',
      'undo',
      'redo',
    ],
  },
  language: 'en',
  image: {
    toolbar: [
      'imageStyle:alignLeft',
      'imageStyle:full',
      'imageStyle:alignRight',
      '|',
      'imageTextAlternative',
    ],
  },
  licenseKey: '',
};
